
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Menu = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <rect x="4.4" y="5.7" width="16.1" height="1.5"></rect>
            <rect x="4.4" y="11.8" width="16.1" height="1.5"></rect>
            <rect x="4.4" y="17.8" width="16.1" height="1.5"></rect>
          </g>
        </g>
      </g>
    </IconBase>);
};

Menu.defaultProps = {
  title: 'Menu',
};

export default Menu;
